import { memo } from "react";
import PropTypes from "prop-types";
import OffersOverview from "app/pages/.shared/OffersOverview/OffersOverview";
import DealTimer from "app/pages/.shared/Deal/DealTimer/DealTimer";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";
import "./AsideOffersOverview.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";

const AsideOffersOverview = ({
	offers = [],
	hour,
	day,
	onClick,
	hideTimer,
	itemClickable = true,
	productPriceValue,
}) => {
	const offerCount = offers.length;

	return (
		<div className="aside-offers-overview">
			{(hour > 0 || day > 0) && !hideTimer && (
				<div className="aside-offers-overview__timer">
					<DealTimer hour={hour} day={day} />
				</div>
			)}

			<div className="aside-offers-overview__offers">
				<OffersOverview offers={offers} clickable={itemClickable} />
				{productPriceValue && <PaymentDescriptionTermsContainer />}
			</div>
			<div className="aside-offers-overview__cta">
				<Button variant="primary" onClick={onClick}>
					{offerCount > 1 ? (
						<FormattedMessage id="product.page.aside.cta.label" />
					) : (
						<FormattedMessage id="product.page.aside.cta.label.single.offer" />
					)}
				</Button>
			</div>
		</div>
	);
};

AsideOffersOverview.propTypes = {
	offers: PropTypes.array,
	hour: PropTypes.number,
	day: PropTypes.number,
	onClick: PropTypes.func,
	productPriceValue: PropTypes.string,
	hideTimer: PropTypes.bool,
	itemClickable: PropTypes.bool,
};

export default memo(AsideOffersOverview);
